export default __webpack_public_path__ + "static/media/tierlitaenzli-chatzeschwaenzli.8db10910.pdf";